module.exports = __webpack_public_path__ + "static/img/tabbar_order_select@2x.f70e6af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tabbar_order_select@2x.png
// module id = NaMi
// module chunks = 1